import { Reducer } from '@reduxjs/toolkit'
import { EventsAction } from './events.actions'
import { GET_EVENTS_SUCCESS, GET_EVENTS_FAILURE, GET_EVENTS_REQUESTED } from './events.constants'

interface EventsState {
  loading: boolean,
  error: boolean,
  data: $TSFIXME[],
}

const initialState = {
  loading: true,
  error: false,
  data: [],
}

const reducer: Reducer<EventsState, EventsAction> = (state = initialState, action) => {
  switch (action.type) {
    case GET_EVENTS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
        data: [],
      }
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.data,
      }

    case GET_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      }

    default:
      return state
  }
}

export default reducer
